/** Shared floating-surface styles for menus, popovers, selects. */
export const floatingPanel =
  'z-50 overflow-hidden rounded-md border border-hairline bg-surface-raised text-ink shadow-lg ' +
  'data-[state=open]:animate-[gh-pop_160ms_var(--gh-ease-out)] data-[state=closed]:animate-[gh-fade_100ms_reverse]';

export const menuItem =
  'relative flex cursor-default select-none items-center gap-2.5 rounded-sm px-2.5 py-2 text-[0.875rem] text-ink-soft outline-none ' +
  'data-[highlighted]:bg-sunken data-[highlighted]:text-ink data-[disabled]:pointer-events-none data-[disabled]:opacity-45 ' +
  '[&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:text-ink-muted data-[highlighted]:[&_svg]:text-ink';
